export const UserData = {
  tabs: [
    {
      label: 'All',
      id: 1,
    },
    {
      label: 'Buyer User',
      id: 2,
    },
    {
      label: 'Temporary User',
      id: 3,
    },
    {
      label: 'Voucher User',
      id: 4,
    }
  ],
};

export const UserDataOne = {
  tabs: [
    {
      label: 'User Detail',
      id: 1,
    },
    {
      label: 'Reset Password',
      id: 2,
    },
    {
      label: 'WishList',
      id: 3,
    },
    {
      label: 'Cart',
      id: 4,
    },
    {
      label: 'Outstanding Payment Detail',
      id: 5,
    },
    {
      label: 'IVS Order',
      id: 6,
    },
    {
      label: 'Download History',
      id: 7,
    },
    {
      label: 'Privillege Download History',
      id: 8
    }
  ],
};

export const AdminUserData = {
  tabs: [
    {
      label: 'All Admins',
      id: 1,
    }
  ],
};


export const UserIdentityData = [
  {
    label: 'Select Identity',
    value: ''
  },
  {
    label: 'Buyer',
    value: 'Buyer',
  },
  {
    label: 'Confirmed',
    value: 'Confirmed',
  },
  {
    label: 'International',
    value: 'International',
  },
  {
    label: 'Photographer',
    value: 'Photographer',
  },
  {
    label: 'Student',
    value: 'Student',
  },
  {
    label: 'Unconfirmed',
    value: 'Unconfirmed',
  },
  {
    label: 'Photographer by us',
    value: 'Photographer by us',
  },
  {
    label: 'Student by us',
    value: 'Student by us',
  },
  {
    label: 'Model',
    value: 'Model',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const MaxByTypeData = [
  {
    label: 'Image',
    value: 'image',
  },
  {
    label: 'Shoot',
    value: 'shootid',
  },
];
export const SearchIVSDownloadBy = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'User ID',
    value: 'user_name',
  },
  {
    label: 'Image Name',
    value: 'image_name',
  },
];
export const SearchBySoldImages = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'Image ID',
    value: 'image_id',
  },
  {
    label: 'User',
    value: 'user_name',
  },
  {
    label: 'Client',
    value: 'client',
  },
  {
    label: 'Company Name',
    value: 'company',
  },
];
export const SearchByStarImages = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Image ID',
    value: 'image_id',
  },
  {
    label: 'Shoot ID',
    value: 'shoot_id',
  },
];
export const SearchByAllmages = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Image ID',
    value: 'image_id',
  },
  {
    label: 'Shoot ID',
    value: 'shoot_id',
  },
  {
    label: 'Contributor',
    value: 'contributor',
  },
];
export const SearchByAllVideos = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Video ID',
    value: 'video_id',
  },
  {
    label: 'Shoot ID',
    value: 'shoot_id',
  },
  // {
  //   label: 'Contributor Name',
  //   value: 'contributor_id',
  // },
];
export const SearchByShoot = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Shoot ID',
    value: 'shoot_id',
  },
  {
    label: 'Category',
    value: 'category',
  },
];

export const SearchBy = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'User ID',
    value: 'user_id',
  },
  {
    label: 'User Name',
    value: 'user_name',
  },
  {
    label: 'Invoice ID',
    value: 'invoice_id',
  },
  {
    label: 'Image Name',
    value: 'image_name',
  },
  {
    label: 'Purchase Order',
    value: 'purchase_order',
  },
  {
    label: 'GST Number',
    value: 'gst_number',
  },
  {
    label: 'Payment Type',
    value: 'payment_type',
  }
];
export const SearchUserBy = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Company Name',
    value: 'company_name',
  },
  {
    label: 'First Name',
    value: 'first_name',
  },
  {
    label: 'Phone Number',
    value: 'mobile',
  },
  {
    label: 'Email',
    value: 'email',
  },
];
export const SearchImageBy = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Image Name',
    value: 'image_name',
  },
  {
    label: 'Status',
    value: 'status',
  },
  {
    label: 'Comment',
    value: 'comment',
  },
];
export const SearchFolderBy = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Folder Name',
    value: 'folder_name',
  },
];
export const SearchByConfirmed = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'Email',
    value: 'user_name',
  },
  {
    label: 'Invoice ID',
    value: 'invoice_id',
  },
  {
    label: 'GST Number',
    value: 'gst_number',
  },
  {
    label: 'Payment Mode',
    value: 'payment_type',
  },
];

export const SearchByAllOrder = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'Email',
    value: 'user_name',
  },
  {
    label: 'Payment Mode',
    value: 'payment_type',
  }
];

export const SearchByRejected = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'Email',
    value: 'user_name',
  },
  {
    label: 'Payment Mode',
    value: 'payment_type',
  },
  {
    label: 'Invoice Id',
    value: 'invoice_id',
  }
];

export const SearchByProposal = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Proposal Id',
    value: 'proposal_id',
  },
  {
    label: 'Created By',
    value: 'created_by',
  }
];

export const SearchByPending = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  // {
  //   label: 'User Id',
  //   value: 'user_id',
  // },
  {
    label: 'Email',
    value: 'user_name',
  },
  {
    label: 'GST Number',
    value: 'gst_number',
  },
  {
    label: 'Payment Mode',
    value: 'payment_type',
  }
];

export const SearchByContributor = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Name',
    value: 'name',
  },

  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Inden Code',
    value: 'inden_code',
  },
  {
    label: 'Address',
    value: 'address',
  },
];
export const SearchByBill = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Bill To',
    value: 'client',
  },
];

export const SearchInCart = [
  {
    label: 'Select',
    value: ''
  },
  {
    label: 'Image Name',
    value: 'image',
  },
  {
    label: 'Email',
    value: 'user_name',
  },
];

export const Select_Sez = [
  {
    label: 'Select SEZ',
    value: '0'
  },
  {
    label: 'SEZ with payment',
    value: '1',
  },
  {
    label: 'SEZ without payment',
    value: '2',
  },
];

export const SearchVoucherBy = [
  {
    label: 'Select',
    value: '0'
  },
  {
    label: 'User ID',
    value: 'user_id',
  },
  {
    label: 'Order ID',
    value: 'order_id',
  },
  {
    label: 'Voucher Email',
    value: 'voucher_email',
  },
];









